// extracted by mini-css-extract-plugin
export default {"ticketNamePrice":"_2v9Mt","description":"_3PMm3"};